import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import FAQTabs from './FAQTabs';

const FAQPage = () => {
    return (
        <div className="faq-page">
            {/* Header Section */}
            <section className="py-5">
                <Container>
                    <div className="text-center mb-5">
                        <h1 className="section-title">SIK SORULAN SORULAR</h1>
                        <p className="lead">
                            Otoprime hakkında merak ettiğiniz tüm soruların cevaplarını bu sayfada bulabilirsiniz.
                        </p>
                    </div>
                </Container>
            </section>

            {/* FAQ Content */}
            <section className="py-5 bg-light">
                <FAQTabs showTitle={false} />
            </section>

            {/* Contact CTA */}
            <section className="py-5">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={8}>
                            <div className="modern-faq-item text-center">
                                <div className="d-flex align-items-start justify-content-center">
                                    <div className="advantage-icon-modern me-3">
                                        <FaEnvelope />
                                    </div>
                                    <div>
                                        <h3 className="modern-faq-question">Aradığınız sorunun cevabını bulamadınız mı?</h3>
                                        <div className="modern-faq-answer">
                                            <p className="mb-4">Merak ettiğiniz diğer sorular için bizimle iletişime geçebilirsiniz.</p>
                                            <div className="d-flex flex-column flex-md-row justify-content-center gap-3">
                                                <Link to="/contact" className="btn-primary btn-lg text-decoration-none">
                                                    <FaEnvelope className="me-2" />
                                                    İletişime Geç
                                                </Link>
                                                <a
                                                    href="tel:+905323873091"
                                                    className="btn btn-outline-dark btn-lg"
                                                    style={{ textDecoration: 'none' }}
                                                >
                                                    <FaPhoneAlt className="me-2" />
                                                    Ara: 0532 387 3091
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
};

export default FAQPage;